import type {
  ContractStatus,
  Tenant,
} from '../../domain/entities/sales.entity';

/**
 * Filtros da tela de Contratos, todos aplicados **no servidor**. `tenant` e
 * `product` não são campos do `Contract` — o back os resolve pela BA atual — mas
 * daqui saem como query param normal.
 *
 * O contato é só o `contactUserId`, resolvido pelo `ContactSearchInput` contra
 * `GET /admin/identity/contacts`; o Sales filtra por `Contract.userId`. O
 * rótulo legível do contato **não** é filtro: fica no `contact-label-cache`,
 * fora da URL.
 */
export interface ContractFilters {
  contractId: string;
  product: string;
  contactUserId: string;
  tenant: Tenant | '';
  status: ContractStatus | '';
  startedFrom: string;
  startedTo: string;
  endedFrom: string;
  endedTo: string;
}

export const EMPTY_CONTRACT_FILTERS: ContractFilters = {
  contractId: '',
  product: '',
  contactUserId: '',
  tenant: '',
  status: '',
  startedFrom: '',
  startedTo: '',
  endedFrom: '',
  endedTo: '',
};

export function countActiveContractFilters(filters: ContractFilters): number {
  return Object.values(filters).filter(Boolean).length;
}

/** Os filtros como query params da listagem; vazio some. */
export function toContractQueryFilters(filters: ContractFilters) {
  return {
    contractId: filters.contractId.trim() || undefined,
    product: filters.product.trim() || undefined,
    userId: filters.contactUserId || undefined,
    status: filters.status || undefined,
    tenant: filters.tenant || undefined,
    startedFrom: filters.startedFrom || undefined,
    startedTo: filters.startedTo || undefined,
    endedFrom: filters.endedFrom || undefined,
    endedTo: filters.endedTo || undefined,
  };
}
